<template>
  <div class="pm-dialog-berth">
    <vs-tabs v-model="activeTab" alignment="center" color='#346c88'>
      <vs-tab v-for="(wharf, index) in wharfList" :key="index" :label="wharf.name" color='#346c88' class="wharf-item">

        <div class="flex justify-center">
          <div class="vs-row flex justify-start berth-list-width">
            <div class="candidate-list vs-col w-1/4" v-for="(master,index) in getBerthListByWharf(wharf.id)" :key="index" >
                <vs-button
                  class="berth-item"
                  :color="(selectedId === master.id) ? '#346c88' : '#828282' "
                  @mousedown="selectedId = (selectedId !== master.id) ? master.id : null"
                >
                  {{ master.label || master.name }}
                </vs-button>
            </div>
          </div>

        </div>

      </vs-tab>
    </vs-tabs>
    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
      >
        保存
      </vs-button>
      <vs-button
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("portMasterDestinationWork");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
  },
  data() {
    return {
      selectedId: null,
      activeTab: 0,
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      let berthMasterList = JSON.parse(JSON.stringify(this.masterMap['berth']));
      berthMasterList.forEach(x => {
        if (!x.wharf || x.wharf.length === 0 ) {
          x.wharf = { id: null, name: "未分類" };
        }
      });
      return berthMasterList;
    },
    enableSave() {
      return true; // ( this.selectedId && this.selectedId >= 0 );
    },
    wharfList() {
      let wharfsList = JSON.parse(JSON.stringify(this.masterMap['wharfs']));
      if ( this.masterList.filter(x => x.wharf.id === null ).length > 0  && !wharfsList.find(x => x.name === "未分類")) {
        wharfsList.push({ id: null, name: "未分類" });
      }
      return wharfsList;
    }
  },
  methods: {
    initData() {
      this.selectedId = this.valueMap ? this.valueMap.id : null;
      this.activeTab = 0;
      this.$nextTick(() => {
        const selectedData = this.masterList.find(x => x.id === this.selectedId);
        if (selectedData) {
          this.wharfList.forEach((wharf, index) => {
            if ( selectedData.wharf && selectedData.wharf.id === wharf.id ) {
              this.activeTab = index;
            }
          });
        }
      });
    },
    onSubmit(isUpdateTimeStamp) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      const updateKeyValueMap = {};
      const updateTargetKey = this.columnKey === 'previous#berth_id' ? this.columnKey : this.columnKey + '#id';
      updateKeyValueMap[updateTargetKey] = this.selectedId;
      this.$emit('updateValue',this.taskId, updateKeyValueMap, mode);
    },
    getBerthListByWharf(wharfId) {
      let berthArray = this.masterList.filter(berth => berth.wharf && berth.wharf.id == wharfId).slice()
      return berthArray.sort((a, b) => {
        const aName = a.label ? a.label : a.name
        const bName = b.label ? b.label : b.name
        if (aName > bName) {
          return 1;
        } else {
          return -1;
        }
      })
    }
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";

.pm-dialog-berth {
  .outer-area {
    padding: 1rem;
  }
  .candidate-list {
    margin: 0rem;
    min-height: 3.2rem;
  }
  .wharf-item {
    max-height: 19rem;
    overflow-x: hidden;
    overflow-y:auto;
  }
  .berth-list-width {
    width: 42rem;
  }
  .berth-item {
    width: 96%;
  }
  .vs-tabs--btn {
    min-height: 3.2rem;
    color: $pm-dark-gray;
    border: 1px solid $pm-navy;
    border-radius: 2px;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    :hover {
      color: $pm-black;
    }
  }
  .activeChild button.vs-tabs--btn {
    background-color:$pm-navy !important;
    span {
      color: $pm-white;
    }
  }
  .vs-tabs--li {
    margin: 0 0.1rem;
  }
  .vs-tabs--ul {
    border-bottom: 4px solid $pm-navy;
  }
  .con-slot-tabs {
    div {
      transition: unset;
    }
  }
  .save-button {
    margin-top: 1rem !important;
    width: 30%;
  }
}
</style>

